import Button from '@Components/Buttons/Button'
import React, { useContext, useMemo } from 'react'
import { PERMISSIONS } from '@Const/permissions'
import { WorkModel } from '@Entities/work/work'
import ViewWorkHeader from '@Components/ViewWork/Headers/ViewWorkHeader'
import PermissionCheck from '@Components/Utility/PermissionCheck'
import { getSourceNameBySourceId } from '@App/helpers/work-entities/utils/get-source-name-by-source-id'
import { getLatestUpdateDate } from '@App/helpers/work-entities/utils/get-latest-updated-date'
import { useLocation } from 'react-router'
import RootStore from '@App/stores/root-store'
import { StoresContext } from '@App/contexts'
import { canMemberEdit } from '@App/helpers/can-member-edit'
import { isOverclaimAllowed } from '@App/helpers/is-overclaim-allowed'
import CopyWorkButton from '@Components/Buttons/CopyWorkButton'

interface CatalogWorkHeaderProps {
    work: WorkModel
    editOnClick: () => void
    claimOnClick: () => void
}

const CatalogWorkHeader = (props: CatalogWorkHeaderProps) => {
    const { work, editOnClick, claimOnClick } = props
    const { userStore, rightsholderStore } = useContext<RootStore>(StoresContext)
    const location = useLocation()
    const isEditable = useMemo(
        () => canMemberEdit(work, rightsholderStore.currentRightsholderId) || userStore.isInternal,
        [work, rightsholderStore.currentRightsholderId, userStore.isInternal]
    )

    return (
        <ViewWorkHeader work={work} backText="< Back to results" showOverclaimLink>
            <PermissionCheck requiredPermissions={[PERMISSIONS.CATALOG_PERMISSIONS.manage_works]} orIsInternal>
                <div className="metadata-button-wrapper">
                    <div className="action-buttons">
                        <CopyWorkButton workId={work.id} work={work} type="secondary-small" />
                        {!location.state?.claimType && isEditable ? (
                            <Button mainColor type="primary-small" onClick={editOnClick}>
                                Edit
                            </Button>
                        ) : (
                            (isOverclaimAllowed(work) || work.totalKnownShares < 100) && (
                                <Button mainColor type="primary-small" onClick={claimOnClick}>
                                    Claim shares on this work
                                </Button>
                            )
                        )}
                    </div>

                    <div className="metadata">
                        {work?.lastUpdated && (
                            <>
                                <div className="last-updated">
                                    Last Edited:{' '}
                                    {getLatestUpdateDate(work)?.toLocaleString('en', {
                                        year: 'numeric',
                                        month: 'long',
                                        day: '2-digit',
                                    }) ?? 'Unknown'}
                                </div>
                                <div className="updated-by">Source: {getSourceNameBySourceId(work?.sourceId)}</div>
                            </>
                        )}
                    </div>
                </div>
            </PermissionCheck>
        </ViewWorkHeader>
    )
}

export default CatalogWorkHeader
